/* This example requires Tailwind CSS v2.0+ */
import React, {ReactNode, useState} from 'react'
import {Switch} from '@headlessui/react'
import classNames from 'classnames'
import {Controller} from "react-hook-form";
import {Control} from "react-hook-form/dist/types";

interface ToggleProps {
    labelPosition?: 'left' | 'right';
    label?: string | ReactNode;
    initialState?: boolean;
    indeterminate?: boolean; // se enabled e indeterminate viene utilizzato un colore diverso!
    onChange?: (newState: boolean) => void;
    auxState?: boolean;
    className?: string;
    switchClassName?: string;
}

const Toggle: React.FC<ToggleProps> = ({
                                           labelPosition = 'right',
                                           label,
                                           initialState = false,
                                           onChange = () => {
                                           },
                                           auxState,
                                           className, switchClassName,
                                           indeterminate
                                       }) => {
    const [enabled, setEnabled] = useState<boolean>(initialState)

    if (typeof auxState === 'boolean' && auxState !== enabled) {
        //console.log('update local state...')
        setEnabled(auxState);
    }

    const color = enabled ? (indeterminate ? 'bg-gray-400' : 'bg-blue-600') : 'bg-gray-200';
    return (
        //<Switch.Group as="div" className={`flex flex-wrap items-center place-content-center ${className}`}>
        <Switch.Group as="div" className={`flex flex-wrap items-center ${className || ''}`}>

            {/*LEFT LABEL*/}
            {
                labelPosition === 'left' && (typeof label === 'string') &&
                <Switch.Label as="span" className="mr-2">
                    <span className="text-sm font-medium">{label}</span>
                </Switch.Label>
            }
            {labelPosition === 'left' && React.isValidElement(label) && label}

            {/* TOGGLE */}
            <Switch as={'a'} checked={enabled}
                    onChange={(newState) => {
                        setEnabled(newState);
                        onChange(newState);
                    }}
                    className={classNames(
                        color,
                        switchClassName,
                        'flex flex-wrap h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent' +
                        'transition-colors duration-200 ease-in-out' +
                        'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2'
                    )}>
                <span aria-hidden="true"
                      className={classNames(
                          enabled ? 'translate-x-5' : 'translate-x-0',
                          'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0' +
                          'transition duration-200 ease-in-out'
                      )}
                />
            </Switch>

            {/*RIGHT LABEL*/}
            {
                labelPosition === 'right' && (typeof label === 'string') &&
                <Switch.Label as="span" className="ml-2">
                    <span className="text-sm font-medium text-gray-600">{label}</span>
                </Switch.Label>
            }
            {labelPosition === 'right' && React.isValidElement(label) && label}
        </Switch.Group>
    )
}
export default Toggle;

interface InputToggleProps extends ToggleProps {
    name: string,
    control: Control<any>,
    defaultValue: boolean,
    rules?: any
}

export const InputToggle: React.FC<InputToggleProps> = ({name, control, defaultValue, rules, onChange, ...rest}) => {
    return <Controller name={name}
                       control={control}
                       defaultValue={defaultValue}
                       rules={rules}
                       render={({field: {value, onChange}, fieldState, formState}) => {
                           return <Toggle auxState={value} initialState={value} onChange={onChange} {...rest}/>
                       }
                       }
    />
}
